import * as moment from 'moment';
import { tz } from 'moment-timezone';
var zones = require('moment-timezone/data/meta/latest.json').zones;
export var getMomentInstance = function (timestamp, useUTC) {
    if (useUTC === void 0) { useUTC = true; }
    return useUTC ? moment(timestamp).utc() : moment(timestamp);
};
export var prettyTimestamp = function (timestamp, timeAgo, withoutSuffix, withoutTime) {
    if (timeAgo === void 0) { timeAgo = false; }
    if (withoutSuffix === void 0) { withoutSuffix = false; }
    if (withoutTime === void 0) { withoutTime = false; }
    var date = new Date(timestamp);
    var momentInstance = moment(date);
    var formatMaybeTime = withoutTime ? 'll' : 'lll';
    return timeAgo ? momentInstance.fromNow(withoutSuffix) : momentInstance.format(formatMaybeTime);
};
export var getFormattedDateString = function (date) {
    return moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD').toString();
};
export var getTimePeriodInDays = function (start, end) {
    var startDate = new Date(start);
    var endDate = new Date(end);
    var msPerDay = 1000 * 60 * 60 * 24;
    var utcStart = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    var utcEnd = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    return Math.floor((utcEnd - utcStart) / msPerDay) + 1;
};
export var getFormattedDateFromTimestamp = function (timestamp, daysOffset) {
    if (daysOffset === void 0) { daysOffset = 0; }
    return moment(timestamp).add(daysOffset, 'day').format('YYYY-MM-DD').toString();
};
export var getFilterFormattedFromDate = function (fromDate) {
    var fromDateList = fromDate.split('-');
    return fromDateList[0] + "-" + fromDateList[1] + "-" + fromDateList[2] + "T00:00:00";
};
export var getFilterFormattedToDate = function (toDate) {
    var toDateList = toDate.split('-');
    return toDateList[0] + "-" + toDateList[1] + "-" + toDateList[2] + "T23:59:59";
};
export var getFilterFormattedDateString = function (date) {
    return moment(date, 'YYYY-MM-DDTHH:MM:SS').format('YYYY-MM-DDTHH:MM:SS').toString();
};
export var getPrettyCalendarDate = function (uglyDate) {
    var date = new Date(uglyDate);
    var momentInstance = moment(date);
    return momentInstance.format('MMM Do YY');
};
export var getPrettyCalendarDateLong = function (timestamp) {
    var date = new Date(timestamp);
    var momentInstance = moment(date);
    return momentInstance.format('MMMM D, YYYY');
};
export var getPrettyDateRange = function (rangeStart, rangeEnd, t, isUtc) {
    if (isUtc === void 0) { isUtc = true; }
    var translateKey = 'app.common.date-range';
    var getNDaysAgo = function (days) { return getMomentInstance(new Date().valueOf(), isUtc).subtract(days, 'days').format('D/M/YYYY'); };
    var currentHour = new Date().getHours();
    var isFirstHourOfTheDay = currentHour === 0;
    var firstHourFix = isFirstHourOfTheDay ? 1 : 0;
    if (rangeEnd !== getNDaysAgo(1) && rangeEnd !== getNDaysAgo(0)) {
        return rangeStart + "-" + rangeEnd;
    }
    if (rangeEnd === getNDaysAgo(0) && rangeEnd === rangeStart) {
        return t(translateKey + ".today");
    }
    if (rangeEnd === getNDaysAgo(1) && rangeStart === rangeEnd) {
        return t(translateKey + ".last-day");
    }
    if (rangeStart === getNDaysAgo(7 - firstHourFix)) {
        return t(translateKey + ".7-days");
    }
    if (rangeStart === getNDaysAgo(30 - firstHourFix)) {
        return t(translateKey + ".30-days");
    }
    if (rangeStart === getNDaysAgo(60 - firstHourFix)) {
        return t(translateKey + ".60-days");
    }
    if (rangeStart === getNDaysAgo(90 - firstHourFix)) {
        return t(translateKey + ".90-days");
    }
    return rangeStart + "-" + rangeEnd;
};
export var secToTimeUnits = function (sec) {
    return ({
        seconds: sec % 60,
        minutes: Math.floor((sec / (60)) % 60),
        hours: Math.floor((sec / (60 * 60)) % 24)
    });
};
export var guessUserCountry = function () {
    var _a, _b;
    var magicalTimezoneGuess = tz.guess;
    return (_b = (_a = zones[magicalTimezoneGuess()]) === null || _a === void 0 ? void 0 : _a.countries[0]) === null || _b === void 0 ? void 0 : _b.toLowerCase();
};
//# sourceMappingURL=index.js.map